import { render, staticRenderFns } from "./BackgroundPicker.vue?vue&type=template&id=455edbdd&scoped=true"
import script from "./BackgroundPicker.vue?vue&type=script&lang=js"
export * from "./BackgroundPicker.vue?vue&type=script&lang=js"
import style0 from "./BackgroundPicker.vue?vue&type=style&index=0&id=455edbdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455edbdd",
  null
  
)

export default component.exports